export const colors = {
  gredient_black_text: {
    color: "transparent",
    background: "linear-gradient(303.52deg,#4c4a49 3.67%,#060502 103.62%)",
    "-webkit-background-clip": "text",
    "-webkit-text-fill-color": "transparent",
  },
  gredient_red_text: {
    color: "transparent",
    background: "linear-gradient(303.52deg, #f66 3.67%, #bb3a58 103.62%)",
    "-webkit-background-clip": "text",
    "-webkit-text-fill-color": "transparent",
  },
  gredient_blue_text: {
    color: "transparent",
    background: "radial-gradient(87.99% 87.99% at 82.56% 82.09%,#39dafd 0,#41b6e6 100%)",
    "-webkit-background-clip": "text",
    "-webkit-text-fill-color": "transparent",
  },
  gredient_violet_text: {
    color: "transparent",
    background: "linear-gradient(259.08deg, #a314d5 .91%,#680182 85.13%)",
    "-webkit-background-clip": "text",
    "-webkit-text-fill-color": "transparent",
  },
  gredient_green_text: {
    color: "transparent",
    background: "linear-gradient(340.15deg,#03e196 -25.3%,#00b586 73.56%)",
    "-webkit-background-clip": "text",
    "-webkit-text-fill-color": "transparent",
  },
  gredient_grey_text: {
    color: "transparent",
    background: "radial-gradient(73.65% 119.96% at 60.14% 60%,#90e3f7 0,#54aac5 100%)",
    "-webkit-background-clip": "text",
    "-webkit-text-fill-color": "transparent",
  },
  gredient_pink_text: {
    color: "transparent",
    background: "linear-gradient(282deg, #ea56c9 97%, #ea5555 0)",
    "-webkit-background-clip": "text",
    "-webkit-text-fill-color": "transparent",
  },
  gredient_yellow_text: {
    color: "transparent",
    background: "linear-gradient(180deg,#ffe78d,#fec77c)",
    "-webkit-background-clip": "text",
    "-webkit-text-fill-color": "transparent",
  },
  gredient_orange_text: {
    color: "transparent",
    background: "linear-gradient(153deg,#f57e03,#efbe7c)",
    "-webkit-background-clip": "text",
    "-webkit-text-fill-color": "transparent",
  },
  gredient_orange_bg: {
    background: "linear-gradient(70deg, rgb(234 135 51), rgb(254 113 96))",
  },
  gredient_blue_bg: {
    background: "linear-gradient(90deg,#239bfb .02%,#26a9fb 30.84%,#2ecdfc 88.7%,#30d5fc 100.02%)",
  },
  gredient_white_bg: {
    background: "linear-gradient(90deg,#fff .02%,#ccc 30.84%,#fff 88.7%,#ccc 100.02%)",
  },
  gredient_violet_bg: {
    background: "linear-gradient(259.08deg, #a314d5 .91%,#680182 85.13%)",
  },
  gredient_light_purple_bg: {
    background: "linear-gradient(259.08deg,#a00fd3 .91%,#ce7ce3 85.13%)",
  },
  gredient_green_bg: {
    background: "linear-gradient(90deg,#6cd594,#40b554)",
  },
  gredient_red_bg: {
    background: "linear-gradient(303.52deg, #f66 3.67%, #bb3a58 103.62%)",
  },
  gredient_bluish_grey_bg: {
    background: "radial-gradient(44.67% 81.61% at 49.69% 33.92%,#3c71a1 0,#164978 100%)",
  },
  gredient_dark_green_bg: {
    background: "radial-gradient(44.67% 81.61% at 49.69% 33.92%,#3ca15e 0,#348f5b 100%) !important;",
  },
  gredient_grey_bg: {
    background: "radial-gradient(73.65% 119.96% at 60.14% 60%,#90e3f7 0,#54aac5 100%)",
  },
  gredient_pink_bg: {
    background: "radial-gradient(circle at 98% 100%,#ff83de,#ea56c3 85%)",
  },
  gradient_dark_grey_color: "radial-gradient(44.67% 81.61% at 49.69% 33.92%,#555555 0,#2b342f 100%) !important",
  gradient_dark_green_color: "radial-gradient(44.67% 81.61% at 49.69% 33.92%,#3ca15e 0,#348f5b 100%) !important;",
  gradient_green_color: "linear-gradient(340.15deg,#03e196 -25.3%,#00b586 73.56%)",
  gradient_red_color: "linear-gradient(303.52deg, #f66 3.67%, #bb3a58 103.62%)",
  blue_color: "#239bfb",
  blue_color_bg: "#2ebafc14",
  btn_gr1: "radial-gradient(65.26% 73.6% at 39.65% -4.24%, rgb(16, 184, 137) 0px, rgba(41, 158, 96, 0.93) 100%)",
  bg1: "#182B49",
  bg2: "#F6F9FF",
  gr_bg: "linear-gradient(90deg, #41b6e6 0%, #39dafd 100%)",
  gr_bg2: "linear-gradient(90deg, #39dafd 0%, #41b6e6 100%)",
  gr_orange: "linear-gradient(70deg, rgb(234 135 51), rgb(254 113 96))",
  orange: "rgb(234 135 51)",
  copy_bg: "#122340",
  blue: "#2c97ea",
  black: "#000000",
  white: "#FFFFFF",
  green: "#41b6e6",
  green2: "#39dafd",
  red: "#ff6f6f",
  purple: "#84479c",
  yellow: "#fbab19",
  black1: "#182B49",
  black2: "#444444",
  dark_gray: "#3b3b3b",
  dark_purple: "#5b0d7c",
  text1: "#555555",
  text2: "#666666",
  text3: "#969696",
  text4: "#aaaaaa",
  text5: "#cccccc",
  border1: "#eeeeee",
  border2: "#3e3e3e",
  border3: "#dddddd",
  footer1: "#1a1b25",
  footer2: "#16171f",
  ftext: "#8D8E92",
};

export const fonts = {
  roboto: "'Roboto', sans-serif",
  poppins: "'Poppins', sans-serif",
  manrope: "'Manrope', sans-serif",
  nunito: "'Nunito', sans-serif",
};
